import { render, staticRenderFns } from "./tapa-emea-2026-banner.vue?vue&type=template&id=c633e8f6&scoped=true&"
import script from "./tapa-emea-2026-banner.vue?vue&type=script&lang=js&"
export * from "./tapa-emea-2026-banner.vue?vue&type=script&lang=js&"
import style0 from "./tapa-emea-2026-banner.vue?vue&type=style&index=0&id=c633e8f6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c633e8f6",
  null
  
)

export default component.exports